export const ClearIndicator = () => null;
